// extracted by mini-css-extract-plugin
export default {"root":"DemandAreas_root__jylK5","modal":"DemandAreas_modal__v2S3C","form":"DemandAreas_form__nqMyZ","subtitle":"DemandAreas_subtitle__Sem67"};